import { Injectable } from '@angular/core';
import { DateUtilService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenDateUtilService extends DateUtilService {
  dateFormat = 'dd.MM.yyyy';
}
